import React from 'react';
import css from './ClubList.module.css';
import clubImg from './club.png'
import { InlineTextButton, PrimaryButton, SecondaryButton } from '../../../components';
function ClubList() {
  return (
    <div className={css.card}>
      <img src={clubImg} alt="" />
      <div className={css.cardContent} >
        <h3>Ranch Select Club</h3>
        <p>A mix of red, white, and rosé wines. New releases, award winners, and favorite classics.</p>
        <p>Available in 3, 6, or 12 bottle shipments,
          5 times per year.
        </p>
        <p>Available in 3, 6, or 12 bottle shipments,
          5 times per year.
        </p>
        {/* <button>Join Now</button> */}
        {/* <PrimaryButton>Join Now</PrimaryButton> */}
        {/* <SecondaryButton>Join Now</SecondaryButton> */}
        <InlineTextButton>Join Now</InlineTextButton>
      </div>
    </div>
  )
}

export default ClubList
